import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import { Link } from "react-router-dom";

export default class UploadArquivo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            planilhas: [],
            selectedFile: null
        }

    }

    async componentDidMount() {
        let planilhas = await this.getDados();
        planilhas = planilhas.data.planilhas
        this.setState({ planilhas });
    }

    getDados = async () => {
        return await api.get("/sti/upload");
    }

    onChange = (event) => {
        this.setState({
            selectedFile: event.target.files[0],
        })
    }

    submit = async (event) => {
        
        event.preventDefault();
        
        const data = new FormData()
        data.append('file', this.state.selectedFile)
        
        let status = await api.post('/sti/upload', data, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress: progressEvent => {
            }
        });

        alert(status.data.status)
        
        this.props.atualizaDados();
        
    }

    render() {
        let { planilhas } = this.state;
        return (
            <Fragment>

                <div className="col-12">
                    {/*<h3 className="text-secondary">Carregar Planilha </h3>*/}
                    <br />
                    <form onSubmit={this.submit} encType="multipart/form-data">

                        <label className="text-secondary">Selecionar arquivo :</label>
                        <div className="input-group">
                            <input type="file" className="form-control" name="upload_file" onChange={this.onChange} />
                            <button type="submit" className="btn btn-outline-primary">Carregar</button>
                        </div>

                    </form>
                </div>

            </Fragment>
        )
    }
}